module.exports = __webpack_public_path__ + "img/img_Colleges4.2a5af3af.png";